/** @jsx jsx */
import { List, Modal, TextGroupMedium, useAlert } from "@cd2/components"
import { useSkeem } from "../providers/SkeemProvider"
import { jsx } from "@emotion/core"
import { useState } from "react"
import { ResetPasswordForm } from "../forms/ResetPasswordForm"
import { useAsyncEffect } from "../hooks/useAsyncEffect"
import { IRecord } from "../types/schema"
import { useGlobalState } from "../utils/globalState"

export function RequirePasswordUpdate() {
  const skeem = useSkeem()
  const alert = useAlert()
  const globalState = useGlobalState()
  const [modalOpen, setModalOpen] = useState(false)

  useAsyncEffect(async () => {
    const me = await skeem.fetchMe<IRecord<"skeem_users", "requirePasswordChange">>([
      "requirePasswordChange",
    ])
    if (me.requirePasswordChange) {
      setModalOpen(true)
    }
  }, [])

  async function handleSubmitPassword({ password }: { password: string }) {
    await skeem.mutate({
      skeem_users: {
        update: {
          id: globalState.user.id,
          skeem_password: password,
          requirePasswordChange: false,
        },
      },
    })
    setModalOpen(false)
    alert.addAlert({ content: "Password updated", status: "ok" })
  }

  return (
    <Modal
      onRequestClose={() => {}}
      isOpen={modalOpen}
      width={600}
      render={() => (
        <List>
          <TextGroupMedium
            heading="Password update required"
            body="You must update your password. Enter your new password below."
          />
          <ResetPasswordForm onSubmit={handleSubmitPassword} submitText="Update password" />
        </List>
      )}
    />
  )
}
